import { Component } from '@angular/core';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-szamlazzhu',
  templateUrl: './szamlazzhu.component.html',
  styleUrls: ['./szamlazzhu.component.scss'],
  imports: [PayeeButtonComponent, RouterLink, RouterLinkActive, RouterOutlet],
})
export class SzamlazzhuComponent {}
